export const authColors = {
  brand: '#000FFF',
  textStrong: '#262626',
  textBody: '#282828',
  textMuted: '#8C8C8C',
  required: '#FF2929',
  disabled: '#D9D9D9',
  success: '#33FF69',
  track: '#E5E7FF',
  surface: '#F2F2F2',
  errorTagBg: '#FFCCCC',
  errorTagText: '#330000',
  white: '#FFFFFF',
} as const;

export const authTypography = {
  titleLarge: { size: '22px', line: '28px', weight: 700 },
  titleMedium: { size: '16px', line: '24px', weight: 700 },
  bodyMedium: { size: '14px', line: '16px', weight: 400 },
  bodySmall: { size: '12px', line: '14px', weight: 400 },
  labelMedium: { size: '12px', line: '16px', weight: 500 },
} as const;

export const authLayout = {
  contentWidth: '1216px',
  footerPadding: '220px',
  formWidth: '352px',
  fieldWidth: '340px',
  mobileBreakpoint: '768px',
  tabletBreakpoint: '1024px',
} as const;

export const authRadius = {
  pill: '1000px',
} as const;
